import { lazy } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

const
  Galeria = lazy(() => import('../../../views/GaleriaPublic/index'))


const Index = (props: any) => {
  return (
    <Switch>
      <Route path={`${props.match.path}`} component={Galeria} />
      <Redirect to='/error/404' />
    </Switch>
  )
}

export default Index
